import { Modal, notification, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoCreateOutline } from "react-icons/io5";
import { ButtonWithIcon } from "../../../components/AntCostomComponents/Buttons";
import api from "../../../utils/api";
import { formatUtcToLocal } from "../../../utils/date.util";
import RegisterKitForm from "../register-kit/register-kit-form";

const RegisterNewKitModal = ({ isVisible, onClose, patientId }) => {
  const [registerKits, setRegisterKits] = useState([]);
  const [innerFormModal, setInnerFormModal] = useState(false);
  const { t } = useTranslation("common");

  useEffect(() => {
    const fetchRegisterKits = async () => {
      try {
        const response = await api.get(`/patients/${patientId}/kits`);

        if (response.status !== 200) {
          throw new Error("Failed to fetch reports");
        }
        const data = await response.data;
        setRegisterKits(data["kits"]);
      } catch (error) {
        console.error("Error fetching register kits:", error);
      }
    };

    fetchRegisterKits();
  }, [patientId]);

  const registerNewKit = async(barcode) => {

    try {
      const response = await api.post(`/kits/assign`, {
        barcode,
        patient_id: patientId,
      });

      setRegisterKits((prevKits) => [
        ...prevKits,
        {
          barcode,
          registered_at: response.data.registered_at,
        }]);

      notification.success({
        message: t("success"),
        description: `${t("barcode")}: ${barcode} ${t("has_been_registered_as_kit")}`,
        placement: "top",
        duration: 3,
      });

      if (response.status !== 201) {
        throw new Error("Failed to register kit");
      }

    } catch (error) {
      console.error("Error registering new kit:", error);

      notification.error({
        message: t("error"),
        description: t("kit_registration_failed"),
        placement: "top",
        duration: 3,
      });
    }

    setInnerFormModal(false);
    onClose();

  }

  const registeredKitsColumns = [
    {
      title: <span className="text-gray-400">{t("no")}</span>,
      key: "index",
      render: (_, __, index) => (
        <span className="text-gray-400">{index + 1}</span>
      ),
    },
    {
      title: <span className="text-gray-400">{t("barcode")}</span>,
      dataIndex: "barcode",
      key: "barcode",
      render: (barcode) => <span className="text-gray-400">{barcode}</span>,
    },
    {
      title: <span className="text-gray-400">{t("date")}</span>,
      dataIndex: "registered_at",
      key: "date",
      render: (date) => (
        <span className="text-gray-300 text-sm">{formatUtcToLocal(date).toLocaleUpperCase()}</span>
      ),
    },
  ];

  const registeredKitsData = registerKits?.map((kit, index) => ({
    ...kit,
    key: kit.id,
    index,
  }));

  return (
    <>
      <Modal
        open={isVisible}
        onCancel={onClose}
        footer={null}
        width={700}
        className="custom-dark-modal"
        title={t("register_new_kit")}
      >
        <Table
          columns={registeredKitsColumns}
          dataSource={registeredKitsData}
          pagination={false}
          className="custom-ant-table"
          locale={{
            emptyText: (
              <div className="text-gray-400 text-sm py-6 text-center">
                {t("no_kits_found")}
              </div>
            ),
          }}
        />

        <div className="mt-4 flex justify-end gap-2">
          <ButtonWithIcon
            text={t("register_new_kit")}
            color="purple"
            icon={IoCreateOutline}
            onClick={() => {
              setInnerFormModal(true);
            }}
          />
        </div>
      </Modal>
      <Modal
        open={innerFormModal}
        onCancel={() => setInnerFormModal(false)}
        footer={null}
        width={700}
        className="custom-dark-modal"
        title={t("register_new_kit")}
      >
        <RegisterKitForm handleSubmit={registerNewKit} />
      </Modal>
    </>
  );
};

export default RegisterNewKitModal;
